module.exports = __webpack_public_path__ + "static/img/IMG_20150307_165253.981e862a.jpg";